var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVilovet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215.69 115.29",
    style: {
      enableBackground: "new 0 0 215.69 115.29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#255088;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,78.99c0.24,2.16,0.42,4.44,0.48,7.2h0.12c0.96-2.52,1.56-4.08,3.36-7.8l9.66-19.68h11.46L22.2,99.21 H9.36L5.04,66.99c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.38-0.48,9.12-0.66,14.1-0.54L17.7,78.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.04,99.21H39.3l4.14-21.48v-0.12c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54 L50.04,99.21z M51.54,67.11c-3.66,0-6.12-2.82-6.12-5.88c0-3.9,3.36-6.72,6.96-6.72c3.6,0,6.12,2.82,6.12,5.76 C58.5,64.29,55.14,67.11,51.54,67.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.66,99.21H58.92l6.78-35.58c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54 L69.66,99.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.34,99.93c-9.54,0-12.66-4.26-12.66-10.86c0-13.32,9.54-20.4,18.9-20.4c9.42,0,12.54,4.74,12.54,11.1 C108.12,91.95,99.18,99.93,89.34,99.93z M93.9,78.15c-4.14,0-6,5.64-6,9.3c0,1.56,0.6,2.94,2.7,2.94c4.5,0,6.24-5.46,6.24-9.18 C96.84,79.17,96.12,78.15,93.9,78.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.32,99.21h-11.28l-4.92-29.82h11.28l0.9,6.36c0.42,3,0.66,6.12,0.78,8.94h0.12l7.56-16.68l10.62,2.88 L127.32,99.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.48,88.41v0.72c0,1.62,0.78,2.34,4.02,2.34c2.88,0,6.06-0.66,9.06-1.8v8.22 c-3.9,1.32-8.34,2.04-12.36,2.04c-8.7,0-11.34-4.38-11.34-10.74c0-13.74,9.18-20.52,17.52-20.52c9,0,10.98,4.38,10.98,8.04 C168.36,84.87,160.62,88.23,150.48,88.41z M156.24,76.65c-2.64,0-4.08,2.7-4.8,5.04c3.66-0.06,6.54-0.9,6.54-3.54 C157.98,77.25,157.44,76.65,156.24,76.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.44,77.79h-5.46l-1.92,10.38c-0.36,2.1,0,2.7,1.68,2.7c1.26,0,2.22-0.18,3.18-0.36l-1.26,8.52 c-2.28,0.6-4.92,0.9-6.9,0.9c-6.84,0-9-3.24-7.56-10.98l2.1-11.16h-3.72l1.68-8.4h3.6l1.62-8.4l11.1-2.1l-1.98,10.5h5.52 L190.44,77.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.63,22.79C211.96,15.4,214.52,4.46,215.69,0c-2.9,3.98-9.35,6.39-13.5,7.4 c-3.78,0.92-11.1,1.93-18.09,5.3c-6.95,3.34-9.73,9.03-11.77,13.37c-2.24,4.77-3.49,12.29-3.49,12.29 C176.93,28.98,182.24,28.08,194.63,22.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.73,30.52c-17.33,7.4-19.9,18.34-21.06,22.8c2.9-3.98,9.35-6.39,13.5-7.39c3.78-0.92,11.1-1.93,18.09-5.3 c6.95-3.34,9.73-9.03,11.77-13.37c2.24-4.77,3.49-12.3,3.49-12.3C204.43,24.34,199.12,25.24,186.73,30.52z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilovet);
export default __webpack_public_path__ + "static/media/Vilovet.67567ded2e8bbae7509e34d73bf858de.svg";
export { ForwardRef as ReactComponent };